"use strict";
//
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update_document_elements = void 0;
const store_1 = require("../../../store");
const api_1 = require("../../api");
function update_document_elements(request) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        const { userState } = store_1.redux_store.getState();
        const { token } = userState;
        // Try draft endpoint first (no FaceTec required)
        const draftResponse = yield new api_1.API().apiPut({
            baseUrl: (_a = process.env.API_URL) !== null && _a !== void 0 ? _a : "",
            endpoint: `draft/update-element`,
            content: request,
            authorization: `${token}`,
        });
        // If draft endpoint succeeds, return response
        if (draftResponse.success) {
            return draftResponse;
        }
        // Fall back to published document endpoint (if it exists)
        return yield new api_1.API().apiPut({
            baseUrl: (_b = process.env.API_URL) !== null && _b !== void 0 ? _b : "",
            endpoint: `update-document-element`,
            content: request,
            authorization: `${token}`,
        });
    });
}
exports.update_document_elements = update_document_elements;
